import React from 'react';
import { Col, Row } from 'reactstrap';
import { Label } from 'edozvola-frontend-lib/dist/ui';
import { Input, Toggle } from 'edozvola-frontend-lib/dist/ui/components';
import { ChamberMemberCodebookModel } from 'app/shared/model/shared.model';
import { useParams } from 'react-router-dom';
import {
  fetchChamberMembersQuery,
  fetchMainProjectTypeQueryForCaseCategory
} from 'app/edozvola/codebooks/codebooks.queries';
import { PaginatedDropdown } from 'edozvola-frontend-lib/dist/ui/components/paginated-dropdown';

export interface ICaseMainProjectDataFormWithNonMandatoryOibProps {
  readOnly: any;
  projectDataFormik: any;
}

const CaseMainProjectDataFormWithNonMandatoryOib = ({ projectDataFormik, readOnly }: ICaseMainProjectDataFormWithNonMandatoryOibProps) => {
  const { id: uuid } = useParams<{ id: string }>();

  const { data: chamberMemberOptions, isLoading: chamberMemberOptionsLoading } = fetchChamberMembersQuery();
  const { data: projectTypeOptions, isLoading: projectTypeOptionsLoading } = fetchMainProjectTypeQueryForCaseCategory(uuid);

  const onChamberMemberChanged = (selected: ChamberMemberCodebookModel[]) => {
    projectDataFormik.setValues({
      ...projectDataFormik.values,
      mainProjectAuthorizedDesigner: {
        authorizationNumber: selected,
        oib: selected[0] ? selected[0].oib : '',
      },
      mainProjectAuthorizationNumberExists: selected.length > 0,
    });
  };

  const authorizationNumberExistsChanged = (value: boolean) => {
    projectDataFormik.setValues({
      ...projectDataFormik.values,
      mainProjectAuthorizedDesigner: {
        authorizationNumber: [],
        oib: '',
      },
      mainProjectDesignerFirstName: '',
      mainProjectDesignerLastName: '',
      mainProjectDesignerTitle: '',
      mainProjectAuthorizationNumberExists: value,
    });
  };

  return (
    <div className={'d-flex justify-content-between flex-column gap-3'}>
      <div className="form-header">Podaci o glavnom projektu</div>
      <Row>
        <Col md={6}>
          <Label labelText={'Vrsta projekta'} />
          <PaginatedDropdown
            placeholder={!readOnly && 'Odaberi vrstu projekta'}
            onItemSelect={selected => projectDataFormik.setFieldValue('mainProjectType', selected)}
            selected={projectDataFormik.values.mainProjectType}
            labelKey={'value'}
            options={projectTypeOptionsLoading ? [] : projectTypeOptions}
            disabled={readOnly}
            error={!readOnly && (projectDataFormik.errors.mainProjectType as string)}
            showErrorMessage
          />
        </Col>
        <Col md={6}>
          <Label labelText={'Zajednička oznaka projekta'} />
          <Input
            disabled={readOnly}
            value={projectDataFormik.values.projectMark}
            id="projectMark"
            name="projectMark"
            maxLength={100}
            onChange={projectDataFormik.handleChange}
            onBlur={projectDataFormik.handleBlur}
            error={!readOnly && projectDataFormik.errors.projectMark ? `${projectDataFormik.errors.projectMark}` : ''}
          />
        </Col>
      </Row>
      <hr />
      <div className={'form-header'}>Ovlašteni projektant</div>
      <Row>
        <Col md={4}>
          <Label labelText={'Broj ovlaštenja/Ime i prezime'} />
          <PaginatedDropdown
            placeholder={!readOnly && 'Odaberi broj ovlaštenja/ime i prezime'}
            onItemSelect={onChamberMemberChanged}
            selected={projectDataFormik.values.mainProjectAuthorizedDesigner.authorizationNumber}
            labelKey={'value'}
            options={chamberMemberOptionsLoading ? [] : chamberMemberOptions}
            clearButton
            disabled={readOnly || !projectDataFormik.values.mainProjectAuthorizationNumberExists}
            error={
              !readOnly &&
              projectDataFormik.errors.mainProjectAuthorizedDesigner &&
              projectDataFormik.errors.mainProjectAuthorizedDesigner['authorizationNumber']
                ? projectDataFormik.errors.mainProjectAuthorizedDesigner['authorizationNumber']
                : ''
            }
            showErrorMessage
          />
        </Col>
        <Col md={2}>
          <Label labelText={'Broj ovlaštenja nepoznat'} />
          <Toggle
            disabled={readOnly}
            checked={!projectDataFormik.values.mainProjectAuthorizationNumberExists}
            value={!projectDataFormik.values.mainProjectAuthorizationNumberExists as any}
            onChange={event => authorizationNumberExistsChanged(!event.target.checked)}
          />
        </Col>
        {projectDataFormik.values.mainProjectAuthorizationNumberExists && (
          <Col md={6}>
            <Label labelText={'OIB'} />
            <Input disabled value={projectDataFormik.values.mainProjectAuthorizedDesigner.oib} />
          </Col>
        )}
        {!projectDataFormik.values.mainProjectAuthorizationNumberExists && (
          <>
            <Col md={6}>
              <Label labelText={'Ime projektanta'} />
              <Input
                disabled={projectDataFormik.values.mainProjectAuthorizationNumberExists ? true : readOnly}
                value={projectDataFormik.values.mainProjectDesignerFirstName}
                error={
                  !readOnly && projectDataFormik.errors.mainProjectDesignerFirstName
                    ? `${projectDataFormik.errors.mainProjectDesignerFirstName}`
                    : ''
                }
                maxLength={100}
                onChange={event => projectDataFormik.setFieldValue('mainProjectDesignerFirstName', event.target.value)}
              />
            </Col>
            <Col md={6}>
              <Label labelText={'Prezime projektanta'} />
              <Input
                disabled={projectDataFormik.values.mainProjectAuthorizationNumberExists ? true : readOnly}
                value={projectDataFormik.values.mainProjectDesignerLastName}
                error={
                  !readOnly && projectDataFormik.errors.mainProjectDesignerLastName
                    ? `${projectDataFormik.errors.mainProjectDesignerLastName}`
                    : ''
                }
                maxLength={100}
                onChange={event => projectDataFormik.setFieldValue('mainProjectDesignerLastName', event.target.value)}
              />
            </Col>
            <Col md={6}>
              <Label labelText={'Zvanje projektanta'} />
              <Input
                disabled={projectDataFormik.values.mainProjectAuthorizationNumberExists ? true : readOnly}
                value={projectDataFormik.values.mainProjectDesignerTitle}
                error={
                  !readOnly && projectDataFormik.errors.mainProjectDesignerTitle
                    ? `${projectDataFormik.errors.mainProjectDesignerTitle}`
                    : ''
                }
                maxLength={100}
                onChange={event => projectDataFormik.setFieldValue('mainProjectDesignerTitle', event.target.value)}
              />
            </Col>
          </>
        )}
      </Row>
    </div>
  );
};

export default CaseMainProjectDataFormWithNonMandatoryOib;
